import React, { createContext, useContext } from 'react';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';
import { withFlags } from '@confluence/flags/entry-points/withFlags';

const FlagsContext = createContext<FlagsStateContainer | undefined>(undefined);

export const FlagsProvider = withFlags(
	({ children, flags }: { children: React.ReactNode; flags: FlagsStateContainer }) => (
		<FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
	),
);

export const useFlags = () => {
	const context = useContext(FlagsContext);
	if (!context) {
		throw new Error('useFlags must be used within a FlagsProvider');
	}
	return context;
};
